function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { solutionURL } from '../endpoints';
import PromiseCache from '../utils/promise-cache';
import FetchWithAuth from '../utils/fetch-with-auth';

function SolutionService(authState) {
  var fetch = new FetchWithAuth(authState);
  var cache = new PromiseCache(authState);

  function listSolutions() {
    return _listSolutions.apply(this, arguments);
  }

  function _listSolutions() {
    _listSolutions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return cache('listSolutions', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var res, json;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        _context2.next = 2;
                        return fetch("".concat(solutionURL, "/solutions"), {
                          headers: {
                            'content-type': 'application/json'
                          }
                        });

                      case 2:
                        res = _context2.sent;
                        _context2.next = 5;
                        return res.json();

                      case 5:
                        json = _context2.sent;
                        return _context2.abrupt("return", json);

                      case 7:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2);
              })))();

            case 2:
              return _context3.abrupt("return", _context3.sent);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _listSolutions.apply(this, arguments);
  }

  var getSolution = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(solutionId) {
      var _yield$listSolutions, solutions;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return listSolutions();

            case 2:
              _yield$listSolutions = _context.sent;
              solutions = _yield$listSolutions.solutions;

              if (!Array.isArray(solutions)) {
                _context.next = 8;
                break;
              }

              if (!solutionId) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return", solutions.find(function (s) {
                return s.id === solutionId;
              }));

            case 7:
              return _context.abrupt("return", solutions[0]);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getSolution(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    listSolutions: listSolutions,
    getSolution: getSolution
  };
}

export default SolutionService;
//# sourceMappingURL=solution.js.map